module.exports = __webpack_public_path__ + "static/media/game_start.007a39e5.wav";